import React from 'react';
import { IconChevronRight } from '@tabler/icons-react';
import './item.list.css';

type Props = {
    title: React.ReactNode;
    leading?: React.ReactNode;
    badges?: React.ReactNode;
    description?: React.ReactNode;
    lines?: 1 | 2 | 3 | 'all';
    meta?: React.ReactNode;
    trailing?: React.ReactNode;
    actions?: React.ReactNode;
    revealActions?: boolean;
    chevron?: boolean;
    titleAttr?: string;
    stack?: 'sm' | 'md' | 'none';
    tailWidth?: number;
};

const stop = (event: React.SyntheticEvent) => event.stopPropagation();

const ItemRow: React.FC<Props> = ({ title, leading, badges, description, lines = 1, meta, trailing, actions, revealActions = false, chevron = false, titleAttr, stack = 'sm', tailWidth }) => (
    <div className="bd-li" data-stack={stack}>
        {leading ? <div className="bd-li-leading" aria-hidden>{leading}</div> : null}
        <div className="bd-li-main">
            <div className="bd-li-headline">
                <span className="bd-li-title" title={titleAttr}>{title}</span>
                {badges ? <span className="bd-li-badges">{badges}</span> : null}
            </div>
            {description ? (
                <div
                    className="bd-li-description"
                    data-lines={lines === 'all' ? 'all' : undefined}
                    style={lines === 'all' ? undefined : ({ '--bd-li-lines': lines } as React.CSSProperties)}
                >
                    {description}
                </div>
            ) : null}
        </div>
        {meta ? <div className="bd-li-meta">{meta}</div> : null}
        <div className="bd-li-tail" style={tailWidth ? { width: `${tailWidth}rem`, justifyContent: 'flex-end' } : undefined}>
            {actions ? (
                <div className="bd-li-actions" data-reveal={revealActions || undefined} onClick={stop} onKeyDown={stop}>
                    {actions}
                </div>
            ) : null}
            {trailing}
            {chevron ? <IconChevronRight size={16} className="bd-li-chevron" aria-hidden /> : null}
        </div>
    </div>
);

export default ItemRow;
